import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { useProjectsStore } from './stores/projects';
import { useNewsStore } from './stores/news';

createApp(App).use(router).use(createPinia()).mount('#app')


const store = useProjectsStore();
const newsStore = useNewsStore();
store.init();
newsStore.init();